// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rxKiR","item":"styles_item__SeAua","title":"styles_title__VfTmr"};